import { defineNuxtPlugin } from 'nuxt/app'
import { capitalizeFirstLetter, formatInteger } from '@/utils/helpers'

export default defineNuxtPlugin({
  name: 'ar-filters',
  parallel: true,
  async setup(app) {
    console.log('SETUP AR_FILTERS')
    app.vueApp.config.globalProperties.$filters = {
      capitalize(val) {
        capitalizeFirstLetter(val)
      },
      commaSeparated(val) {
        return formatInteger(val)
      },
    }
  },
})
